import {API} from '../API';

const reports = {
    getIncomeReport: async (filters = {}) => {
        const {data: response} = await API.get(`/reports/income`, {
            params: filters,
        });

        return response;
    },
    getBoxesReport: async (filters = {}) => {
        const {data: response} = await API.get(`/reports/boxes`, {
            params: filters,
        });
        return response;
    },
    getUserAgesReport: async () => {
        const {data: response} = await API.get(`/reports/users/age`);
        return response;
    },
    getActiveUsersReport: async () => {
        const {data: response} = await API.get(`/reports/users/active`);
        return response;
    },
    getUserSignUpsReport: async (filters = {}) => {
        const {data: response} = await API.get(`/reports/users/count`, {
            params: filters,
        });
        return response;
    },
    getFutureBookings: async () => {
        const {data: response} = await API.get(`/reports/bookings/future`);
        return response;
    },
    getRelevancePromotedManual: async (filters = {}) => {
        const {data: response} = await API.get(
            '/reports/relevance/promoted/manual',
            {
                params: filters,
            },
        );
        return response;
    },
    getRelevancePromotedComputed: async (filters = {}) => {
        const {data: response} = await API.get(
            '/reports/relevance/promoted/computed',
            {
                params: filters,
            },
        );
        return response;
    },
    getRelevanceDemand: async (filters = {}) => {
        const {data: response} = await API.get('/reports/relevance/demand', {
            params: filters,
        });
        return response;
    },
    getRelevanceDistribution: async () => {
        const {data: response} = await API.get(
            '/reports/relevance/distribution',
        );
        return response;
    },
    getRelevanceHealth: async () => {
        const {data: response} = await API.get('/reports/relevance/health');
        return response;
    },
    getRelevanceEventFacts: async (eventId, filters = {}) => {
        const {data: response} = await API.get(
            `/reports/relevance/events/${eventId}/facts`,
            {
                params: filters,
            },
        );
        return response;
    },
};

export default reports;
